import React from "react";
import AboutNavBar from "../components/AboutNavBar";
import UiServicesDetails from "../components/UiServicesDetails";
import UiServicesContent from "../components/UiServicesContent";
import Footer from "../components/Footer";
import RenderLinks from "../components/RenderLinks";
import { Helmet } from "react-helmet-async";

function ShopifyDevelopment() {
  const siteUrl = "https://microcodesoftware.com"; // Base URL
  const pagePath = "/shopify-development"; // Dynamic path if needed
  return (
    <div>
      <Helmet>
        <title>Shopify Development Company | Custom Shopify Solutions</title>
        <meta
          name="description"
          content="Build a high-converting, mobile-friendly Shopify store with Microcode Software. Custom themes, app development, migration & ongoing support—everything you need!"
        />
        <meta
          name="keywords"
          content="Ecommerce website designing, Ecommerce website designing company, Ecommerce website designing company in Delhi, Ecommerce website development Delhi, Ecommerce website designing company Delhi, Ecommerce website designing company Delhi NCR"
        />

        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${siteUrl}${pagePath}`} />
      </Helmet>
      <RenderLinks />
      <AboutNavBar />
      <UiServicesDetails />
      <UiServicesContent />
      <Footer />
    </div>
  );
}

export default ShopifyDevelopment;
